
import React from 'react'
import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    const { txt, language } = this.props
    return (
      <div className='no-gift'>
        <div className={`contant ${language === 'ar' ? 'arlang' : ''}`}>
          <p>{txt}</p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/no-gift/index.js